import type { Template } from "@/types";

export const PO_05_H4_V1: Template[] = [
{
    id: "po-05-h4v1-01",
    name: "PO 01 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 60, y: 258, width: 488, height: 335, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 672, y: 212, width: 199, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 672, y: 358, width: 199, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 672, y: 503, width: 199, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 879, y: 212, width: 279, height: 428, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-05-h4v1-02",
    name: "PO 02 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_02.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 185, y: 87, width: 240, height: 163, rotation: 0, imageRotation: 0 },
        { id: "2", x: 185, y: 258, width: 240, height: 163, rotation: 0, imageRotation: 0 },
        { id: "3", x: 185, y: 429, width: 240, height: 163, rotation: 0, imageRotation: 0 },
        { id: "4", x: 185, y: 600, width: 240, height: 163, rotation: 0, imageRotation: 0 },
        { id: "5", x: 702, y: 87, width: 422, height: 677, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-03",
    name: "PO 03 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 33, y: 215, width: 299, height: 208, rotation: 0, imageRotation: 0 },
        { id: "2", x: 33, y: 431, width: 299, height: 207, rotation: 0, imageRotation: 0 },
        { id: "3", x: 340, y: 0, width: 538, height: 851, rotation: 0, imageRotation: 0 },
        { id: "4", x: 886, y: 215, width: 299, height: 208, rotation: 0, imageRotation: 0 },
        { id: "5", x: 886, y: 431, width: 299, height: 207, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-04",
    name: "PO 04 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 27, y: 163, width: 560, height: 390, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 27, y: 561, width: 182, height: 128, rotation: 0, imageRotation: 0 },
        { id: "3", x: 217, y: 561, width: 181, height: 128, rotation: 0, imageRotation: 0 },
        { id: "4", x: 406, y: 561, width: 181, height: 128, rotation: 0, imageRotation: 0 },
        { id: "5", x: 742, y: 163, width: 343, height: 527, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-05-h4v1-05",
    name: "PO 05 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_05.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 31, y: 331, width: 273, height: 188, rotation: 0, imageRotation: 0 },
        { id: "2", x: 312, y: 331, width: 273, height: 188, rotation: 0, imageRotation: 0 },
        { id: "3", x: 175, y: 135, width: 274, height: 189, rotation: 0, imageRotation: 0 },
        { id: "4", x: 175, y: 527, width: 274, height: 188, rotation: 0, imageRotation: 0 },
        { id: "5", x: 727, y: 135, width: 371, height: 581, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-05-h4v1-06",
    name: "PO 06 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 353, width: 205, height: 144, rotation: 0, imageRotation: 0 },
        { id: "2", x: 213, y: 353, width: 204, height: 144, rotation: 0, imageRotation: 0 },
        { id: "3", x: 425, y: 135, width: 368, height: 581, rotation: 0, imageRotation: 0 },
        { id: "4", x: 801, y: 353, width: 205, height: 144, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1013, y: 353, width: 204, height: 144, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-07",
    name: "PO 07 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 0, width: 542, height: 851, rotation: 0, imageRotation: 0 },
        { id: "2", x: 670, y: 194, width: 485, height: 336, rotation: 0, imageRotation: 0 },
        { id: "3", x: 670, y: 538, width: 157, height: 120, rotation: 0, imageRotation: 0 },
        { id: "4", x: 835, y: 538, width: 156, height: 120, rotation: 0, imageRotation: 0 },
        { id: "5", x: 999, y: 538, width: 156, height: 120, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-08",
    name: "PO 08 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 75, y: 66, width: 460, height: 719, rotation: 0, imageRotation: 0 },
        { id: "2", x: 658, y: 248, width: 252, height: 174, rotation: 0, imageRotation: 0 },
        { id: "3", x: 918, y: 248, width: 251, height: 174, rotation: 0, imageRotation: 0 },
        { id: "4", x: 658, y: 430, width: 252, height: 174, rotation: 0, imageRotation: 0 },
        { id: "5", x: 918, y: 430, width: 251, height: 174, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-09",
    name: "PO 09 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 221, width: 568, height: 407, rotation: 0, imageRotation: 0 },
        { id: "2", x: 576, y: 221, width: 374, height: 273, rotation: 0, imageRotation: 0 },
        { id: "3", x: 576, y: 502, width: 183, height: 127, rotation: 0, imageRotation: 0 },
        { id: "4", x: 767, y: 502, width: 183, height: 127, rotation: 0, imageRotation: 0 },
        { id: "5", x: 958, y: 221, width: 258, height: 407, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-10",
    name: "PO 10 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_10.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 222, width: 175, height: 127, rotation: 0, imageRotation: 0 },
            { id: "2", x: 183, y: 222, width: 174, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 357, width: 357, height: 271, rotation: 0, imageRotation: 0 },
            { id: "4", x: 365, y: 222, width: 564, height: 406, rotation: 0, imageRotation: 0 },
            { id: "5", x: 937, y: 222, width: 279, height: 406, rotation: 0, imageRotation: 0 }
    ],
}
];